import EVImg from '@components/EVImg';
import AspectBox from '@components/Layout/AspectBox';
import ConditionallyWrapWithUrl from '@components/MiscComponents/ConditionallyWrapWithUrl';
import { RightArrow } from '@icon/index';
import { FC } from 'react';
import { DevelopmentCardInner, ImageGradient, Title } from './styles';

interface DevelopmentCardProps {
  img: object | string;
  title: string;
  imageAspectRatio: number;
  url: string | null;
  isExternal?: boolean;
  dataTestId?: string;
}

export const DevelopmentCard: FC<DevelopmentCardProps> = ({
  img,
  title,
  imageAspectRatio,
  url,
  isExternal = false,
}) => {
  return (
    <AspectBox $ratio={imageAspectRatio}>
      <DevelopmentCardInner>
        <ConditionallyWrapWithUrl href={url} target={isExternal}>
          {typeof img === 'object' ? (
            <EVImg imageFocalPointData={img} sizes={['90vw', '50vw', '33vw', '600px']} />
          ) : (
            <EVImg src={img} sizes={['90vw', '50vw', '33vw', '600px']} />
          )}
          <ImageGradient />
          <Title>
            <span>{title}</span>
            <RightArrow />
          </Title>
        </ConditionallyWrapWithUrl>
      </DevelopmentCardInner>
    </AspectBox>
  );
};

export default DevelopmentCard;
